import { useBreakpointValue } from '@genial/utils';
import React, { useEffect } from 'react';

import { TradingConsolidateItem } from '../../../../../../../store/trading/types';

import { TradingListItemDesktop } from './Desktop';
import { TradingListItemMobile } from './Mobile';
import { TradingListItemTablet } from './Tablet';

export declare namespace TradingListItemTypes {
  export interface Props {
    item: TradingConsolidateItem;
    isLast?: boolean;
  }

  export interface Content {
    item: TradingConsolidateItem;
    purchaseQtyChanged: boolean;
    executeQtyChanged: boolean;
    saleQtyChanged: boolean;
    positionChanged: boolean;
    operationChanged: boolean;
    lastUpdatedAt?: Date;
    isLast?: boolean;
  }
}

export const TradingListItem: React.FC<TradingListItemTypes.Props> = ({ item, isLast }) => {
  const [purchaseQtyChanged, setPurchaseQtyChanged] = React.useState(false);
  const [executeQtyChanged, setExecuteQtyChanged] = React.useState(false);
  const [saleQtyChanged, setSaleQtyChanged] = React.useState(false);
  const [positionChanged, setPositionChanged] = React.useState(false);
  const [operationChanged, setOperationChanged] = React.useState(false);
  const [lastUpdatedAt, setLastUpdatedAt] = React.useState<Date | undefined>(undefined);

  const itemProps = {
    isLast,
    item,
    purchaseQtyChanged,
    executeQtyChanged,
    saleQtyChanged,
    positionChanged,
    operationChanged,
    lastUpdatedAt,
  };

  const content = useBreakpointValue({
    base: <TradingListItemMobile {...itemProps} />,
    sm: <TradingListItemTablet {...itemProps} />,
    md: <TradingListItemDesktop {...itemProps} />,
  });

  useEffect(() => {
    setOperationChanged(true);
    setLastUpdatedAt(new Date());

    setTimeout(() => {
      setOperationChanged(false);
    }, 100);
  }, [item.position]);

  useEffect(() => {
    setPurchaseQtyChanged(true);
    setLastUpdatedAt(new Date());

    setTimeout(() => {
      setPurchaseQtyChanged(false);
    }, 100);
  }, [item.purchaseQty]);

  useEffect(() => {
    setExecuteQtyChanged(true);
    setLastUpdatedAt(new Date());

    setTimeout(() => {
      setExecuteQtyChanged(false);
    }, 100);
  }, [item.executedQty]);

  useEffect(() => {
    setSaleQtyChanged(true);
    setLastUpdatedAt(new Date());

    setTimeout(() => {
      setSaleQtyChanged(false);
    }, 100);
  }, [item.saleQty]);

  useEffect(() => {
    setPositionChanged(true);
    setLastUpdatedAt(new Date());

    setTimeout(() => {
      setPositionChanged(false);
    }, 100);
  }, [item.position]);

  return content;
};
